exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-header{display:block;margin-left:-15px;margin-right:-15px}loans-header.mobile{margin-left:-30px;margin-right:-30px}loans-header.mobile header{height:60px}loans-header.mobile header h1{font-size:18px}loans-header header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;background-color:#49a5e6;height:111px;max-width:1200px;padding:33px 30px;width:100%}loans-header header h1{color:#fff;font-size:34px;font-weight:300;line-height:1.32;margin:0}loans-header header .btn.btn-app.btn-default{height:48px;line-height:49px;padding:0;width:167px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/components/loansHeader/loansHeader.scss
// module id = 2152
// module chunks = 0